<template>
    <div>
        <Dialog v-model:visible="visible" header="Select Incidents" :style="{ width: '50rem' }" @hide="emit('hide-dialog')" modal>
            <!-- Users Selection AutoComplete -->
            <IncidentsPicker @incident-selected="incidentSelected" />
            <!-- Show chips of active users selected -->
            <template v-if="activePanelIncidents.length">
                <div class="my-3">
                    <h6>Selected Incidents:</h6>
                    <div class="flex flex-wrap gap-2 userchips-container overflow-y-auto">
                        <IncidentsChips :incidents="activePanelIncidents" @remove-user="removeSelectedIncident" @remove-all-selected="removeAllSelected" />
                    </div>
                </div>
            </template>
            <template #footer>
                <Button label="Close" severity="warning" @click="emit('hide-dialog')" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>

import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { incidentStore } from '@/store/global-stores';
import IncidentsPicker from '@/modules/user/components/IncidentsPicker.vue';
import IncidentsChips from '@/modules/user/components/IncidentsChips.vue';

const emit = defineEmits(['incident-selected', 'hide-dialog']);

const { activePanelIncidents } = storeToRefs(incidentStore);
const visible = ref(true);

// Formats array of Incident's ids of activePanelIncidents
const selectedIncidentId = computed(() => {
    return activePanelIncidents.value?.map((user) => user.id);
});

// Watches over any changes in the activePanelIncidents and keeps emitting the updates
watch(
    () => selectedIncidentId.value,
    () => emit('incident-selected', selectedIncidentId.value),
    {
        deep: true,
    }
);

// Everytime an incident is selected on UsersPicker, it triggers this function.
const incidentSelected = (incidentDetails) => {

    // Make sure the userDetails is unique before pushing
    const incidentExists = activePanelIncidents.value?.find((incident) => incident.id === incidentDetails.id);
    if (!incidentExists) {
        activePanelIncidents.value?.push(incidentDetails);
    }
};

// If any selected user is removed from UserChips, then this function is triggered
const removeSelectedIncident = (incidentId) => {
    // Check if user id exists
    const incidentIndex = activePanelIncidents.value?.findIndex((incident) => incident.id === incidentId);
    // If it exists, then remove it
    if (incidentIndex !== -1) {
        activePanelIncidents.value?.slice(incidentIndex, 1);
    }
};

// This function is triggered when all users are removed at once from UserChips
const removeAllSelected = () => {
    activePanelIncidents.value = [];
};
</script>

<style scoped>
.userchips-container {
    max-height: 10vh;
}
</style>
